import { createSVGWrapper } from "./SVGWrapper";

/**
 * @deprecated This icon is deprecated. Please use Lucide React icons instead.
 * @see https://lucide.dev/ for available icons
 * @example
 * import { Package } from "lucide-react";
 * // Use <Package /> instead
 */
export const GenericAppIcon = createSVGWrapper(
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 2.375C3.10254 2.375 2.375 3.10254 2.375 4V9C2.375 9.89746 3.10254 10.625 4 10.625H9C9.89746 10.625 10.625 9.89746 10.625 9V4C10.625 3.10254 9.89746 2.375 9 2.375L4 2.375ZM3.625 4C3.625 3.79289 3.79289 3.625 4 3.625L9 3.625C9.20711 3.625 9.375 3.79289 9.375 4V9C9.375 9.20711 9.20711 9.375 9 9.375H4C3.79289 9.375 3.625 9.20711 3.625 9L3.625 4Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 2.375C14.1025 2.375 13.375 3.10254 13.375 4V9C13.375 9.89746 14.1025 10.625 15 10.625H20C20.8975 10.625 21.625 9.89746 21.625 9L21.625 4C21.625 3.10254 20.8975 2.375 20 2.375L15 2.375ZM14.625 4C14.625 3.79289 14.7929 3.625 15 3.625L20 3.625C20.2071 3.625 20.375 3.79289 20.375 4L20.375 9C20.375 9.20711 20.2071 9.375 20 9.375H15C14.7929 9.375 14.625 9.20711 14.625 9V4Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.375 15C2.375 14.1025 3.10254 13.375 4 13.375H9C9.89746 13.375 10.625 14.1025 10.625 15V20C10.625 20.8975 9.89746 21.625 9 21.625H4C3.10254 21.625 2.375 20.8975 2.375 20L2.375 15ZM4 14.625C3.79289 14.625 3.625 14.7929 3.625 15L3.625 20C3.625 20.2071 3.79289 20.375 4 20.375H9C9.20711 20.375 9.375 20.2071 9.375 20V15C9.375 14.7929 9.20711 14.625 9 14.625H4Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 13.375C14.1025 13.375 13.375 14.1025 13.375 15V20C13.375 20.8975 14.1025 21.625 15 21.625H20C20.8975 21.625 21.625 20.8975 21.625 20L21.625 15C21.625 14.1025 20.8975 13.375 20 13.375H15ZM14.625 15C14.625 14.7929 14.7929 14.625 15 14.625H20C20.2071 14.625 20.375 14.7929 20.375 15L20.375 20C20.375 20.2071 20.2071 20.375 20 20.375H15C14.7929 20.375 14.625 20.2071 14.625 20V15Z"
      fill="currentColor"
    />
  </>
);
